import {default as cx} from "classnames"

export const ENTERPRISE_ADMIN_ROLE_TABS = ["Orientee", "Preceptor", "Educator", "Metrics & Reports", "Administrator", "Enterprise Admin"]
export const ADMIN_ROLE_TABS = ["Orientee", "Preceptor", "Educator", "Metrics & Reports", "Administrator"]

export const TAB_ACCESS = {
    "Administrator": ADMIN_ROLE_TABS,
    "Educator": ["Orientee"],
    "Enterprise Admin": ENTERPRISE_ADMIN_ROLE_TABS,
}

export const getVisibleTabs = (userRole) => {
    return TAB_ACCESS[userRole] ?? []
}

export const canOnboardOrientees = (userRole) => {
    return ["Enterprise Admin", "Administrator", "Educator"].includes(userRole)
}

export const canAddUsers = (userRole) => {
    return ["Enterprise Admin", "Administrator", "Educators"].includes(userRole)
}

function RoleLink({tab, active, onChange, count}) {
    return (
        <li className="nav-item flex-fill">
            <button
                type="button"
                className={cx("nav-link btn btn-light-primary btn-active-primary px-3 py-3 fw-bold w-100", {
                    active: tab === active,
                })}
                onClick={() => onChange(tab)}
            >
                {tab}
                {count !== undefined && <span className="badge badge-light ms-2">{count}</span>}
            </button>
        </li>
    )
}

const RoleTabs = ({tabs, active, onChange, counts = {}}) => (
    <ul className="nav nav-group mx-auto fs-5 justify-content-start bg-light shadow-sm fw-bold my-8 gap-2 flex-wrap">
        {tabs.map((t) => (
            <RoleLink key={t} tab={t} active={active} onChange={onChange} count={counts[t]} />
        ))}
    </ul>
)

export default RoleTabs
